/* eslint-disable @typescript-eslint/no-unused-vars */
import { gql } from '@apollo/client';

export const createUserMutation = gql`
  mutation createUser(
    $firstName: String!
    $lastName: String!
    $middleName: String!
    $email: String!
    $roles: String!
    $phone: String!
    $workspaceEmail: String
  ) {
    createUser(
      firstName: $firstName
      lastName: $lastName
      middleName: $middleName
      email: $email
      roles: $roles
      phone: $phone
      workspaceEmail: $workspaceEmail
    ) {
      success
      errors
      customErrors {
        field
        message
        code
      }
    }
  }
`;

export const updateUserMutation = gql`
  mutation updateUserSettings(
    $pk: ID!
    $firstName: String!
    $lastName: String!
    $middleName: String!
    $email: String!
    $roles: String!
    $phone: String!
  ) {
    updateUserSettings(
      userId: $pk
      userSettingsInput: {
        firstName: $firstName
        lastName: $lastName
        middleName: $middleName
        email: $email
        roles: $roles
        phone: $phone
      }
    ) {
      user {
        id
      }
      customErrors {
        field
        message
        code
      }
    }
  }
`;

export const deleteUserMutation = gql`
  mutation deleteUser($pk: ID!) {
    deleteUserSettings(userId: $pk) {
      success
      errors
    }
  }
`;

export const addUserRolesMutation = gql`
  mutation addUserRoles($roles: String!, $userId: ID!) {
    appendRolesUserSettings(roles: $roles, userId: $userId) {
      user {
        id
      }
    }
  }
`;

/**
 * ТЗ 0083 — рабочая почта Google Workspace сотрудника. Привязывает только
 * Admin: ERP читает ящик через доступ ко всему домену, указать адрес =
 * получить доступ к его письмам. Пустой `email` — отвязать. Имя операции
 * отличается от поля `setStaffMailbox`.
 */
export const LinkStaffMailboxMutation = gql`
  mutation LinkStaffMailbox(
    $userId: ID!
    $email: String!
    $displayName: String
    $scope: String
  ) {
    setStaffMailbox(
      userId: $userId
      email: $email
      displayName: $displayName
      scope: $scope
    ) {
      success
      customErrors {
        field
        code
        message
      }
      mailbox {
        email
        displayName
        enabled
        scope
      }
    }
  }
`;

/**
 * ТЗ 0083 — проба доступа к рабочей почте через Google. Свою — любой
 * сотрудник, чужую — только Admin. `ok: null` — локальный стенд, Google не
 * опрашивается. Имя операции отличается от поля `checkStaffMailbox`.
 */
export const ProbeStaffMailboxMutation = gql`
  mutation ProbeStaffMailbox($userId: ID) {
    checkStaffMailbox(userId: $userId) {
      success
      ok
      code
      message
      customErrors {
        field
        code
        message
      }
    }
  }
`;
